import React from "react";

// Profile
import UserProfile from "../pages/Authentication/UserProfile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Unauthorized from "pages/Unauthorized/Unauthorized";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import LockScreen from "../pages/Authentication/AuthLockScreen";

import Authmiddleware from "./middleware/Authmiddleware";
import { PERMISSIONS } from "constants/permissionTypes";
import { MODULES } from "constants/modulesTypes";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

import ContactEnquiryList from "../pages/ContactEnquiry/ContactEnquiryList";

import RoleList from "../pages/Role/RoleList";
import RolePermission from "../pages/Role/RolePermission";

import UserList from "../pages/User/UserList";
import AddEditUser from "../pages/User/AddEditUser";
import UserPermission from "../pages/User/UserPermission";

import BatchList from "../pages/Batch/BatchList";
import BatchStudentList from "../pages/Batch/BatchStudentList";
import StudentsFinalList from "../pages/StudentsFinalList/StudentsFinalList";
import AttendanceList from "../pages/AttendanceList/AttendanceList";
import ClassConfirmation from "../pages/ClassConfirmation/ClassConfirmation";

import StudentList from "../pages/Student/StudentList";
import StudentHistory from "../pages/Student/StudentHistory";
import AddEditStudent from "../pages/Student/AddEditStudent";

import PaymentList from "../pages/Payment/PaymentList";
import AddEditPayment from "../pages/Payment/AddEditPayment";

import HolidayList from "../pages/Holiday/HolidayList";

import NotificationList from "../pages/Notification/NotificationList";

import ReportList from "../pages/Report/ReportList";
import AttendanceReport from "../pages/Report/AttendanceReport";
import CancellationReport from "../pages/Report/CancellationReport";
import CompClassReport from "../pages/Report/CompClassReport";
import FixClassReport from "../pages/Report/FixClassReport";
import NoShowReport from "../pages/Report/NoShowReport";
import CloseClassReport from "../pages/Report/CloseClassReport";
import PauseProfileReport from "../pages/Report/PauseProfileReport";
import SummaryReport from "../pages/Report/SummaryReport";
import TroublemakerReport from "../pages/Report/TroublemakerReport";
import PaymentStatusReport from "../pages/Report/PaymentStatusReport";

const userRoutes = [
  {
    path: "/dashboard",
    component: (
      <Authmiddleware module={MODULES.DASHBOARD} permission={PERMISSIONS.VIEW}>
        <Dashboard />
      </Authmiddleware>
    ),
  },

  {
    path: "/contact-enquiries",
    component: (
      <Authmiddleware module={MODULES.CONTACTENQUIRIES} permission={PERMISSIONS.VIEW}>
        <ContactEnquiryList />
      </Authmiddleware>
    ),
  },

  {
    path: "/roles",
    component: (
      <Authmiddleware module={MODULES.ROLES} permission={PERMISSIONS.VIEW}>
        <RoleList />
      </Authmiddleware>
    ),
  },
  {
    path: "/role-permission/:id",
    component: (
      <Authmiddleware module={MODULES.ROLEPERMISSION} permission={PERMISSIONS.VIEW}>
        <RolePermission />
      </Authmiddleware>
    ),
  },

  {
    path: "/users",
    component: (
      <Authmiddleware module={MODULES.USERS} permission={PERMISSIONS.VIEW}>
        <UserList />
      </Authmiddleware>
    ),
  },
  {
    path: "/user/create",
    component: (
      <Authmiddleware module={MODULES.USERS} permission={PERMISSIONS.INSERT}>
        <AddEditUser />
      </Authmiddleware>
    ),
  },
  {
    path: "/user/view/:id",
    component: (
      <Authmiddleware module={MODULES.USERS} permission={PERMISSIONS.VIEW}>
        <AddEditUser />
      </Authmiddleware>
    ),
  },
  {
    path: "/user/edit/:id",
    component: (
      <Authmiddleware module={MODULES.USERS} permission={PERMISSIONS.EDIT}>
        <AddEditUser />
      </Authmiddleware>
    ),
  },
  {
    path: "/user-permission/:id",
    component: (
      <Authmiddleware module={MODULES.USERPERMISSION} permission={PERMISSIONS.VIEW}>
        <UserPermission />
      </Authmiddleware>
    ),
  },

  {
    path: "/batches",
    component: (
      <Authmiddleware module={MODULES.BATCHES} permission={PERMISSIONS.VIEW}>
        <BatchList />
      </Authmiddleware>
    ),
  },
  {
    path: "/batch/view/:day/:time",
    component: (
      <Authmiddleware module={MODULES.BATCHES} permission={PERMISSIONS.VIEW}>
        <BatchStudentList />
      </Authmiddleware>
    ),
  },

  {
    path: "/students-final-list",
    component: (
      <Authmiddleware module={MODULES.FINALLIST} permission={PERMISSIONS.VIEW}>
        <StudentsFinalList />
      </Authmiddleware>
    ),
  },

  {
    path: "/attendance-list",
    component: (
      <Authmiddleware module={MODULES.ATTENDANCE} permission={PERMISSIONS.VIEW}>
        <AttendanceList />
      </Authmiddleware>
    ),
  },

  { path: "/class-confirmation", component: <ClassConfirmation /> },

  {
    path: "/students",
    component: (
      <Authmiddleware module={MODULES.STUDENTS} permission={PERMISSIONS.VIEW}>
        <StudentList />
      </Authmiddleware>
    ),
  },
  {
    path: "/student/create",
    component: (
      <Authmiddleware module={MODULES.STUDENTS} permission={PERMISSIONS.INSERT}>
        <AddEditStudent />
      </Authmiddleware>
    ),
  },
  {
    path: "/student/view/:id",
    component: (
      <Authmiddleware module={MODULES.STUDENTS} permission={PERMISSIONS.VIEW}>
        <AddEditStudent />
      </Authmiddleware>
    ),
  },
  {
    path: "/student/edit/:id",
    component: (
      <Authmiddleware module={MODULES.STUDENTS} permission={PERMISSIONS.EDIT}>
        <AddEditStudent />
      </Authmiddleware>
    ),
  },
  {
    path: "/student/history/:id",
    component: (
      <Authmiddleware module={MODULES.STUDENTS} permission={PERMISSIONS.VIEW}>
        <StudentHistory />
      </Authmiddleware>
    ),
  },

  {
    path: "/payments",
    component: (
      <Authmiddleware module={MODULES.PAYMENTS} permission={PERMISSIONS.VIEW}>
        <PaymentList />
      </Authmiddleware>
    ),
  },
  {
    path: "/payment/create",
    component: (
      <Authmiddleware module={MODULES.PAYMENTS} permission={PERMISSIONS.INSERT}>
        <AddEditPayment />
      </Authmiddleware>
    ),
  },
  {
    path: "/payment/view/:id",
    component: (
      <Authmiddleware module={MODULES.PAYMENTS} permission={PERMISSIONS.VIEW}>
        <AddEditPayment />
      </Authmiddleware>
    ),
  },
  {
    path: "/payment/edit/:id",
    component: (
      <Authmiddleware module={MODULES.PAYMENTS} permission={PERMISSIONS.EDIT}>
        <AddEditPayment />
      </Authmiddleware>
    ),
  },

  {
    path: "/holidays",
    component: (
      <Authmiddleware module={MODULES.HOLIDAYS} permission={PERMISSIONS.VIEW}>
        <HolidayList />
      </Authmiddleware>
    ),
  },

  {
    path: "/notifications",
    component: (
      <Authmiddleware module={MODULES.NOTIFICATIONS} permission={PERMISSIONS.VIEW}>
        <NotificationList />
      </Authmiddleware>
    ),
  },

  {
    path: "/reports",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <ReportList />
      </Authmiddleware>
    ),
  },
  {
    path: "/attendance-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <AttendanceReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/cancellation-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <CancellationReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/compclass-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <CompClassReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/fixclass-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <FixClassReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/noshow-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <NoShowReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/closeclass-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <CloseClassReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/pauseprofile-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <PauseProfileReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/summary-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <SummaryReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/troublemaker-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <TroublemakerReport />
      </Authmiddleware>
    ),
  },
  {
    path: "/paymentstatus-report",
    component: (
      <Authmiddleware module={MODULES.REPORTS} permission={PERMISSIONS.VIEW}>
        <PaymentStatusReport />
      </Authmiddleware>
    ),
  },

  { path: "/profile", component: <UserProfile /> },
  { path: "/", component: <Dashboard /> },
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/unauthorized", component: <Unauthorized /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
];

export { userRoutes, authRoutes };
